module.exports = __webpack_public_path__ + "img/logo_pc.9597c8f8.png";